<template>
    <app-layout>
        <asset-details-header />
        <div class="py-6">
            <card>
                <template #header><h3 class="mb-0">Performance</h3></template>
                <performance-data-table />
            </card>
        </div>
    </app-layout>
</template>
<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import AssetDetailsHeader from '@/Pages/Assets/Details/AssetDetailsHeader.vue';
import PerformanceDataTable from '@/Pages/Assets/Details/PerformanceData/PerformanceDataTable.vue';
import Card from '@/Components/Card.vue';
</script>
